import React from "react";
import { providerLabel } from "../../utils/providers";

/** Order providers are shown / charged in (matches the backend). */
export const COMBO_PROVIDER_ORDER = [
  "internet",
  "dvpl",
  "railtel",
  "pioneeriptv",
  "watcho",
  "playboxtv",
  "etvwin",
  "vrplay",
];

export const BROADBAND = ["internet", "dvpl", "railtel"];

/** Name shown for a provider inside combos. The portal calls the broadband
 *  provider just "Pioneer", which reads as Pioneer IPTV next to it. */
export const comboLabel = (provider) =>
  provider === "internet" ? "Internet (Pioneer)" : providerLabel(provider);

/** Readable message from an axios error or a plain Error. */
export const errMsg = (err, fallback = "Something went wrong") =>
  err?.response?.data?.error ||
  err?.response?.data?.message ||
  err?.message ||
  fallback;

/** "21 Oct 2026" from "2026-10-21 23:59:59" (no time zone shifting). */
export const fmtDay = (value) => {
  if (!value) return "";
  const m = String(value).match(/^(\d{4})-(\d{2})-(\d{2})/);
  if (!m) return String(value);
  const months = ["Jan", "Feb", "Mar", "Apr", "May", "Jun", "Jul", "Aug", "Sep", "Oct", "Nov", "Dec"];
  return `${Number(m[3])} ${months[Number(m[2]) - 1]} ${m[1]}`;
};

/** "21 Oct 2026, 03:45 pm" */
export const fmtDayTime = (value) => {
  if (!value) return "";
  const d = new Date(String(value).replace(" ", "T"));
  if (Number.isNaN(d.getTime())) return String(value);
  return d.toLocaleString("en-IN", {
    day: "2-digit", month: "short", year: "numeric",
    hour: "2-digit", minute: "2-digit", hour12: true,
  });
};

/** Client-generated id so a double click can never charge twice. */
export const newRequestKey = () => {
  try {
    if (window.crypto && window.crypto.randomUUID) return window.crypto.randomUUID();
  } catch (e) {
    /* fall through */
  }
  return `k${Date.now().toString(36)}${Math.random().toString(36).slice(2, 10)}`;
};

/** Plan chips for one combo: "Pioneer IPTV · SD Pack" with FREE on bonus items. */
export const ComboChips = ({ items = [] }) => (
  <div className="cmb-chips">
    {items.map((it) => (
      <span
        key={`${it.provider}-${it.plan_id}`}
        className={`cmb-chip ${it.is_free ? "cmb-chip--free" : ""}`}
        title={it.plan_error || undefined}
      >
        <strong>{comboLabel(it.provider)}</strong>
        <span>{it.plan_name || "—"}</span>
        {it.is_free ? <em>FREE</em> : null}
      </span>
    ))}
  </div>
);
